<template>
    <div class="documentation-data">
        <ul class="sub-navigation">
                <li><h1>系统通知</h1></li>
                <li @click="linkTo(doc)" v-for="(doc, index) in docList" :key="index">
                    <p :class="[currentId == doc.noticeId && 'active']">{{doc.noticeTitle}}</p>
                </li>
        </ul>
     <div class="con">
        <h1>{{detail.noticeTitle}}</h1>
          <p class="sub-title">
           <span><i class="iconfont icon-caijishijian"></i> 发布时间 ：{{detail.createTime}}</span>
           <span><i class="iconfont icon-user"></i> 发布人: {{detail.createUser}}</span>
          </p>
        <div class="con_text" v-html="detail.noticeContent"> </div>
        </div>
    </div>

</template>

<script>
import documentList from '@/components/documentation/list'
import documentDetail from '@/components/documentation/detail'
export default {
    data(){
        return {
            menu: true,
            currentId: null,
            docList: [],
            detail:{}
        }
    },
    components: {
      documentList,
      documentDetail
    },
    beforeRouteEnter: (to, from, next) => {
        next();
    },
    computed: {
      documentView: {
        get(){
          let store = this.$store.state.docStore.documentation
          return store.componentName
        }
      }
    },
    watch: {
        '$route'(to, from){
            this.toggleRoute(to.name)
        }
    },
    mounted(){
        this.getDocCateList();
        this.toggleRoute(this.$router.currentRoute.name)
    },
    methods:{
        toggleRoute( name ){
            if(name == 'doc_detail'){
                this.menu = false
            } else {
                this.menu = true
            }
        },
        linkTo( item ){
            this.currentId =item.noticeId;
            this.getDocListById(this.currentId)
        },

        async getDocCateList(){
          //TODO:
          //this.$store.commit('updateOutComponentLoading', true)
             let result = await this.$http.get('api/notice/list')
             this.$store.commit('updateOutComponentLoading', false)
             if(result){
             this.docList = result.filter( item => item.noticeType == "1");
            }
        //    console.log(this.docList)
            // this.docList = result.data;
            if(result.length){
                this.currentId = this.docList[0].noticeId;
                console.log(this.currentId)
                this.getDocListById(this.currentId)
            }
        },
        async getDocListById(noticeId){
            let result = await this.$http.post('api/notice/noticeId', { noticeId: noticeId});
            this.$store.commit('updateOutComponentLoading', false)
            if(result){
                this.detail = result
            }
        }
    }
};
</script>

<style lang="scss" scoped>
    .sub-title{
            line-height: 40px;
            font-size: 12px;
            border-bottom: 1px solid #cccccc;
            color:#666666;
            margin-bottom: 20px;
            .iconfont{
                font-size: 14px;
            }
            span{
                padding-right: 30px;
            }
        }
    .con{
        margin-left:350px;
        padding-top: 50px;
        padding-right: 30px;
        margin-bottom: 150px;
        h1{
            margin-bottom: 10px;
            font-size: 18px;
            font-weight: 600;
        }
        .con_text{
            margin-left: 20px;
        }
    }
    .documentation-root{
        padding-top:20px;
        padding-right: 50px;
        margin-left: 320px;
        .table-center{
            text-align: center;
        }
        .table-base tr:nth-child(2n){
            background: #fff;
        }
        .table-base tr:nth-child(2n+1){
            background: #d4edfa;
        }
        .documentation_container{
            min-height: 749px;
            margin-bottom: 20px;
        }
    }
    .documentation-data{
        min-height: 100%;
        border-top: 1px solid transparent;
        .sub-navigation{
            width: 320px;
            top:0px;
            background: #fff;
             border-right:1px solid #ccc ;
             border-top:1px solid #ccc ;
            li{
                line-height: 1;
                height: auto;
                color: #2c3e50;
                border-bottom:1px solid #ccc ;
                margin: 0px 10px;
            }
            li:hover{
                background:#fff;
            }
            h1{
                font-size:20px;
                font-weight: 600;
                color: #2c3e50;
                height: 56px;
                line-height: 56px;
            }
            p{
                line-height: 40px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis
            }
            p:hover{
                background:#eef0f1;
            }
            p.active{
                background:#f3f3f3;
                color: #354052;
            }
            .detail{
                line-height: 57px;
                font-size: 17px;
            }
        }
        .table-base tr td{
            cursor: pointer;
        }
    }
</style>



// WEBPACK FOOTER //
// src/component/base-systemnotice-tongzhi.vue